document.addEventListener('DOMContentLoaded', () => {
  const sideCartDrawer = document.getElementById('drawer');
  const sideCartItems = sideCartDrawer.querySelector('ul[role="list"]'); // Tailwind UI list
  const subtotalEl = sideCartDrawer.querySelector('.js-subtotal');
  

  // ====================================================
  // Funkcija za formatiranje cene u $ XX.XX
  function formatMoney(cents) {
    return `$${(cents / 100).toFixed(2)}`;
  }

  // update item number in nav
  function updateNavCartCount(count) {
    const navCart = document.querySelector('.js-nav-cart sup');
    
    if (count > 0) {
        if (navCart) {
        navCart.textContent = `(${count})`;
        } else {
        // Ako sup ne postoji, kreiramo ga
        const a = document.querySelector('.js-nav-cart');
        const sup = document.createElement('sup');
        sup.className = 'w-5 h-5 !-mx-2 !my-2 z-10';
        sup.textContent = `(${count})`;
        a.appendChild(sup);
        }
    } else {
        if (navCart) navCart.remove();
    }
    }


  // ====================================================
  // Render proizvoda u sidecart
  async function updateCartDrawer() {
    const res = await fetch('/cart.js');
    const cart = await res.json();
    updateNavCartCount(cart.item_count);
    

    // Obrisi prethodne stavke
    sideCartItems.innerHTML = '';

    cart.items.forEach(item => {
      const li = document.createElement('li');
    //   const availableInventory = item.variant.inventory_quantity;
    
    console.log(item);
      li.className = 'flex py-6';

      li.innerHTML = `
        <div class="w-26 h-auto shrink-0 overflow-hidden">
            <a class="text-sm uppercase leading-tight" href="${item.url}">
                <img src="${item.image.replace(/(\.[^/.]+$)/, '_200x$1')}" alt="${item.title}" class="w-full h-auto object-cover">
            </a>
        </div>

        <div class="!ml-4 flex flex-1 flex-col justify-betwee">
          <div>
            <div class="flex justify-between text-base weidemann text-gray-900 !mb-3">
              <h3 class="leading-none"><a class="text-sm" href="${item.url}">${item.title}</a></h3>
              <p class="!ml-4 text-sm">${formatMoney(item.final_line_price)}</p>
            </div>
          </div>
          <div class="flex flex- items-en justify-between text-sm !mb-3">
            <div class="flex gap-2 text-gray-500">
                <span>Quantity:</span>
                <div class="flex items-center" data-available="${item.inventory_quantity}">
    <button 
        type="button" 
        class="js-qty-change w-3 h-5 flex items-center justify-center" 
        data-variant-id="${item.variant_id}" 
        data-change="-1"
    >−</button>
    <span class="min-w-[2ch] text-center js-quantity-num">${item.quantity}</span>
    <button 
        type="button" 
        class="js-qty-change w-3 h-5 flex items-center justify-center" 
        data-variant-id="${item.variant_id}" 
        data-change="1"
    >+</button>
</div>
            </div>
            
          </div>
          <div class="flex">
              <button type="button" class="js-remove-item text-xs text-gray-400 hover:text-gray-500" data-item-id="${item.variant_id}">Remove</button>
            </div>
        </div>
      `;

      sideCartItems.appendChild(li);
    });

    // Subtotal
    if (subtotalEl) {
  let total = cart.total_price || 0;
  subtotalEl.textContent = formatMoney(total);
} else {
  console.warn('subtotalEl not found!');
}
  }

  // ====================================================
  // Otvori drawer i renderuj proizvode
  async function openSideCart() {
    await updateCartDrawer();
    sideCartDrawer.showModal(); // Tailwind Plus Elements
  }

  // ====================================================
  // Add to Cart dugme

    document.querySelectorAll('.js-add-to-cart').forEach(btn => {
        btn.addEventListener('click', async e => {
        e.preventDefault();

        // Disable dugme i promeni tekst
        const originalText = btn.textContent;
        btn.textContent = 'Adding...';
        btn.disabled = true;
        btn.classList.add('opacity-60', 'cursor-not-allowed');

        const form = btn.closest('form');
        const formData = new FormData(form);

        try {
            await fetch('/cart/add.js', { method: 'POST', body: formData });
            await openSideCart();
        } catch (error) {
            console.error('Greška pri dodavanju u korpu:', error);
        } finally {
            // Vrati dugme u početno stanje
            btn.textContent = originalText;
            btn.disabled = false;
            btn.classList.remove('opacity-60', 'cursor-not-allowed');
        }
        });
    });

  // ====================================================
  // Dugme u navigaciji (otvori sidecart)
  const navCartBtn = document.querySelector('.js-open-cart');
  if (navCartBtn) {
    navCartBtn.addEventListener('click', async e => {
        e.preventDefault(); // blokira standardno href ponašanje
        await openSideCart(); // otvara mini cart
    });
    }

  // ====================================================
  // Remove dugme u sidecart
  sideCartDrawer.addEventListener('click', async e => {
    if (e.target.matches('.js-remove-item')) {
      const variantId = e.target.dataset.itemId;
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: 0 } })
      });
      await updateCartDrawer();
    }
  });

    // ====================================================
    // Promena količine (+ / -)
    // sideCartDrawer.addEventListener('click', async e => {
    // if (e.target.matches('.js-qty-change')) {
    //     const btn = e.target;
    //     const variantId = btn.dataset.variantId;
    //     const change = parseInt(btn.dataset.change, 10);

    //     // Pronađi trenutnu količinu u UI
    //     const qtySpan = btn.parentElement.querySelector('span');
    //     const currentQty = parseInt(qtySpan.textContent, 10);
    //     const newQty = Math.max(currentQty + change, 0); // ne dozvoljava ispod 0

    //     // Ako je nova količina 0 — brišemo proizvod
    //     if (newQty === 0) {
    //     await fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ updates: { [variantId]: 0 } })
    //     });
    //     } else {
    //     await fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ updates: { [variantId]: newQty } })
    //     });
    //     }

    //     await updateCartDrawer();
    // }
    // });
    // ====================================================
// Promena količine (+ / -)
sideCartDrawer.addEventListener('click', async e => {
  if (e.target.matches('.js-qty-change')) {
    const btn = e.target;
    const variantId = btn.dataset.variantId;
    const change = parseInt(btn.dataset.change, 10);
    // const parentLi = btn.closest('li');
    // parentLi.classList.add('opacity-40');
    // const qtyNum = btn.parentElement.querySelector('.js-quantity-num');
    // qtyNum.innerHTML = `<img src="/assets/spinner.svg" alt="spinner">`;



    // Pronađi trenutnu količinu u UI
    const qtySpan = btn.parentElement.querySelector('span');
    const currentQty = parseInt(qtySpan.textContent, 10);
    const newQty = Math.max(currentQty + change, 0); // ne dozvoljava ispod 0

    // Ako je nova količina 0 — brišemo proizvod
    if (newQty === 0) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: 0 } })
      });
    } else {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [variantId]: newQty } })
      });
    }

    // Update sidecart
    await updateCartDrawer();

    // Ako smo na /cart stranici — osveži je
    if (window.location.pathname === '/cart') {
      window.location.reload();
    }
  }
});



    // 
    
    // track quantity ///////////////////////////////////////////////////////////////////
    // sideCartDrawer.addEventListener('click', async e => {
    // if (e.target.matches('.js-qty-change')) {
    //     const btn = e.target;
    //     const variantId = btn.dataset.variantId;
    //     const change = parseInt(btn.dataset.change, 10);

    //     // Pronađi trenutnu količinu u UI
    //     const qtySpan = btn.parentElement.querySelector('span');
    //     const currentQty = parseInt(qtySpan.textContent, 10);

    //     // Uzmi maksimalnu dostupnu količinu sa data-available
    //     const maxQty = parseInt(btn.parentElement.dataset.available, 10);

    //     // Izračunaj novu količinu i ograniči na [0, maxQty]
    //     const newQty = Math.min(Math.max(currentQty + change, 0), maxQty);

    //     // Ako je nova količina 0 — brišemo proizvod
    //     if (newQty === 0) {
    //     await fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ updates: { [variantId]: 0 } })
    //     });
    //     } else {
    //     await fetch('/cart/update.js', {
    //         method: 'POST',
    //         headers: { 'Content-Type': 'application/json' },
    //         body: JSON.stringify({ updates: { [variantId]: newQty } })
    //     });
    //     }

    //     await updateCartDrawer();
    // }
    // });



  // ====================================================
  // Event kada se drawer otvori preko Tailwind Plus UI dugmeta
  sideCartDrawer.addEventListener('dialog:open', updateCartDrawer);
});




